import React, { ReactNode } from 'react'

// Export individual providers
export {
  CertificateProvider,
  useCertificateContext,
} from './CertificateProvider'
export { PinProvider, usePinContext } from './PinProvider'
export { SessionProvider, useSessionContext } from './SessionProvider'
export { LoginProvider, useLoginContext } from './LoginProvider'
export {
  DocumentSigningProvider,
  useDocumentSigningContext,
} from './DocumentSigningProvider'
export {
  StoredDocumentProvider,
  useStoredDocumentContext,
} from './StoredDocumentProvider'

// Export types
export type { CertificateSelection } from './CertificateProvider'
export type { StoredDocument, SigningParams } from '../types'

// Import providers for combined component
import { CertificateProvider } from './CertificateProvider'
import { PinProvider } from './PinProvider'
import { SessionProvider } from './SessionProvider'
import { LoginProvider } from './LoginProvider'
import { DocumentSigningProvider } from './DocumentSigningProvider'
import { StoredDocumentProvider } from './StoredDocumentProvider'

// Combined provider component
export const SigningProviders: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  return (
    <CertificateProvider>
      <PinProvider>
        <SessionProvider>
          <LoginProvider>
            <DocumentSigningProvider>
              <StoredDocumentProvider>{children}</StoredDocumentProvider>
            </DocumentSigningProvider>
          </LoginProvider>
        </SessionProvider>
      </PinProvider>
    </CertificateProvider>
  )
}
